import { Container as PaginationContainer } from "../../../../../hooks/useOnScrollPagination";
import { ParticipationRow } from "../../../../modules/Participation/ParticipationRow";
import { BackButton } from "../../../../common/BackButton"
import { HeaderContainer } from "../../Details.styles";
import { ListContainer } from "../Participations/Participations.styles";
import { useParticipationsDetail } from "./ParticipationsDetail.hooks";
import { Container } from "./ParticipationsDetail.styles";
import { ParticipationsLoading } from "../../../../modules/LoadingPlaceholders/ParticipationsLoading";

export const ParticipationsDetail = () => {
  const { activeTab, goBack, data, handleChangePage } = useParticipationsDetail();
  return (
    <Container>
      <HeaderContainer>
        <BackButton onClick={goBack} />
        <h3>{activeTab.name}</h3>
      </HeaderContainer>
      {(data.data.results.length === 0 && data.isLoading) && 
        <ListContainer>
          <ParticipationsLoading />
          <ParticipationsLoading />
          <ParticipationsLoading />
        </ListContainer>
      }
      {data.data.results.length > 0 &&
        <PaginationContainer onLastElementVisible={handleChangePage}>
          <ListContainer>
            {data.data.results.map((each, index: number) => (
              <ParticipationRow key={index} data={each} />
            ))}
            {data.isLoading &&
              <>
                <ParticipationsLoading />
                <ParticipationsLoading />
              </>
            }
          </ListContainer>
        </PaginationContainer>
    
      }
    </Container>
  )
}
